import React, { forwardRef, memo } from 'react'
import { Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useEditableContainer } from './EditableContainer.hooks'

// eslint-disable-next-line no-unused-vars
const EditableContainer = forwardRef((props, _ref) => {
	const [
		{ className, children, classes, isBannerActive, label, visible, rootRef, wrapper },
		{ handleAdd },
	] = useEditableContainer(props)

	if (isBannerActive) {
		const element = (
			<div ref={rootRef} className={clsx(classes.root, className)}>
				<Button
					variant="text"
					startIcon={<AddIcon />}
					classes={{
						root: classes.button,
						startIcon: classes.icon,
					}}
					onClick={handleAdd}
				>
					{label}
				</Button>
			</div>
		)
		return wrapper ? wrapper({ children: element }) : element
	}

	return visible && (wrapper ? wrapper({ children }) : children)
})

EditableContainer.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	visible: PropTypes.bool,
	defaultValue: PropTypes.string,
	withoutBanner: PropTypes.bool,
	fieldConfig: PropTypes.object,
	onAdd: PropTypes.func,
	usePaperColors: PropTypes.bool,
	white: PropTypes.oneOf([false, true, 'theme']),
	shadow: PropTypes.bool,
	editable: PropTypes.bool,
	label: PropTypes.string,
	wrapper: PropTypes.func,
	sx: PropTypes.shape({
		white: PropTypes.shape({
			lg: PropTypes.oneOf([false, true, 'theme']),
			md: PropTypes.oneOf([false, true, 'theme']),
			sm: PropTypes.oneOf([false, true, 'theme']),
			xs: PropTypes.oneOf([false, true, 'theme']),
		}),
		shadow: PropTypes.shape({
			lg: PropTypes.bool,
			md: PropTypes.bool,
			sm: PropTypes.bool,
			xs: PropTypes.bool,
		}),
	}),
}

export default memo(EditableContainer)
